import { useEffect } from "react";
import { useLocation } from "react-router-dom";


/**
 * Pushes a virtual page view to GTM dataLayer on every SPA route change.
 * This ensures GTM triggers (Page View, History Change) fire correctly
 * in a single-page React app where full page reloads don't occur.
 */
export const GTMRouteTracker = () => {
  const location = useLocation();

  useEffect(() => {
    // Skip admin/auth routes (GTM doesn't load there anyway)
    if (location.pathname.startsWith("/admin") || location.pathname.startsWith("/auth")) {
      return;
    }

    // Push virtual page view to dataLayer
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "virtualPageview",
      pagePath: location.pathname + location.search,
      pageTitle: document.title,
    });
  }, [location.pathname, location.search]);

  return null;
};
